import React from 'react'
import { Link } from 'gatsby'
import { Body, Box, NavigationMenu } from '.'
import { Logo, MadeByPodAndHive } from '../widgets'
import { CallToAction, FAQ } from '..'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { useGSAP } from '@gsap/react'
import './Shell.scss'

gsap.registerPlugin(useGSAP)
gsap.registerPlugin(ScrollTrigger)

const loggedIn = typeof window !== 'undefined' && window.localStorage.getItem('socket.authenticatedUser')

export const Shell = ({ className, callToAction = true, faqs = true, children }) => {
  return <>
    <header>
      <Box>
        <Box className="mobile-only">
          <NavigationMenu />
        </Box>
        <Box gap={24}>
          <Link to="/" style={{ lineHeight: 1, display: 'flex', alignItems: 'center' }}>
            <Logo />
          </Link>
          <Box className="desktop-only" gap={24}>
            <MadeByPodAndHive />
          </Box>
        </Box>
      </Box>

      <Box gap={24} className="desktop-only">
        <PageLink to="/how-it-works">How it works</PageLink>
        <PageLink to="/model">The model</PageLink>
        <PageLink to="/pricing">Pricing</PageLink>

        <Box gap={8}>
          {!loggedIn && <FreeSquizButton />}
          <ShivooLinkButton />
          {!loggedIn && <ShivooLinkButton login />}
        </Box>
      </Box>
    </header>

    <main className={className} id="scrollTarget">
      <Box column fullWidth fullHeight overflow="hidden" maxWidth="100dvw" justifyContent="center" alignItems="center">
        {children}
        {callToAction && <CallToAction />}
        {faqs && <FAQ />}
      </Box>
    </main>

    <footer>
      <Box className="desktop-only" gap={16}>
        <Logo />
        <MadeByPodAndHive />
      </Box>
      <Box className="links">
        <LegalsLink to="/terms">T&Cs</LegalsLink>
        <LegalsLink to="/privacy">Privacy Policy</LegalsLink>
        <LegalsLink to="/agreement">Partner Agreement</LegalsLink>

        <Body size={14}>@ 2025 Shivoo. All rights reserved</Body>
      </Box>
    </footer>
  </>
}

export const ScrollReset = ({ children }) => (
  <Box onClick={() => setTimeout(() => document.getElementById('scrollTarget').scrollIntoView({ behavior: 'smooth' }), 100)}>
    {children}
  </Box>
)

const LegalsLink = ({ to, children }) => (
  <ScrollReset>
    <Link to={to} className="legal-link">
      <Body size={14} underline>
        {children}
      </Body>
    </Link>
  </ScrollReset>
)

const PageLink = ({ to, children }) => (
  <ScrollReset>
    <Link to={to}>
      <Body alt weight={600} spacing="-0.16px" lineHeight="23px" size={16} style={{ whiteSpace: 'nowrap' }}>
        {children}
      </Body>
    </Link>
  </ScrollReset>
)

export const ShivooLinkButton = ({ login }) => (
  <a className="button-anchor" href={`/shivoo/${(loggedIn || login) ? '' : '?signup'}`} style={{ whiteSpace: 'nowrap' }}>
    {login ? 'Login' : loggedIn ? 'Dashboard' : 'Sign up'}
  </a>
)

export const FreeSquizButton = () => (
  <a className="button-anchor" href="/shivoo/?free" style={{ whiteSpace: 'nowrap' }}>
    Try for FREE
  </a>
)